import { useQuery } from "@tanstack/react-query";

import { List } from "../../../views/supportal/GlobalLists/GlobalVariableListDetailView";
import API from "../../api/API";

function useGlobalList(listAPIName: string) {
  const globalList = useQuery<List>({
    queryKey: ["globalList", listAPIName],
    queryFn: () => {
      return API.getGlobalVariableListByID(listAPIName).then(
        (data) => {
          return data.data.data.list;
        },
        (err) => {
          console.error(err);
        }
      );
    },
    enabled: !!listAPIName,
  });

  return { list: globalList.data, loading: globalList.isLoading };
}

export default useGlobalList;
